(function(app) {

    app.provider("marketingTrackerActOnApi",
        [
            function() {
                this.$get = [
                    "marketingTrackerApiGateway", function(marketingTrackerApiGateway) {
                        var service = {};

                        service.authorize = function () {
                            return marketingTrackerApiGateway.get("/Acton/Token/Authorize");
                        };

                        service.token = function () {
                            return marketingTrackerApiGateway.get("/Acton/Token/Exists");
                        };
                        
                        service.connect = function () {
                            return marketingTrackerApiGateway.get("/Acton/Token/Connect");
                        };

                        service.disconnect = function () {
                            return marketingTrackerApiGateway.delete("/Acton/Token/Disconnect");
                        };

                        service.getActonLists = function () {
                            return marketingTrackerApiGateway.getArray("/Acton/GetLists");
                        };

                        service.postRespondersToActonList = function(listId, responders) {
                            return marketingTrackerApiGateway.post("/Acton/AddContactsToList/" + listId, responders);
                        };

                        service.getCampaigns = function() {
                            return marketingTrackerApiGateway.getArray("/Acton/GetCampaigns");
                        };

                        service.getCampaignAssets = function(campaignId) {
                            return marketingTrackerApiGateway.get("/Acton/GetCampaignAssets/" + campaignId);
                        };

                        service.getMessageReport = function(messageId) {
                            return marketingTrackerApiGateway.get("/Acton/GetCampaigns/MessageReport/" + messageId);
                        };

                        service.getMessageReportForMonthAndYear = function (month, year) {
                            return marketingTrackerApiGateway.get("/Acton/GetCampaigns/MessageReport/Month/" + month + "/Year/" + year);
                        };

                        service.getFormLog = function(formLogId) {
                            return marketingTrackerApiGateway.get("/Acton/GetFormLog/" + formLogId);
                        };

                        service.getLatestFormLog = function() {
                            return marketingTrackerApiGateway.get("/Acton/GetFormLog/Latest");
                        };

                        service.getFormLogList = function() {
                            return marketingTrackerApiGateway.get("/Acton/GetFormLogs");
                        };

                        service.getFormLogListByDateRange = function (startDate, endDate) {
                            return marketingTrackerApiGateway.get("/Acton/GetFormLogsByDateRange?startDate=" + startDate + "&endDate=" + endDate);
                        };

                        service.getFormLogById = function(formId) {
                            return marketingTrackerApiGateway.get("/Acton/GetFormLog/" + formId);
                        };

                        //service.getFormDataByTimeframe = function (startDate, endDate) {
                        //    return marketingTrackerApiGateway.get("/Acton/Metrics?startDate=" + startDate + "&endDate=" + endDate,
                        //        {
                        //            params: {
                        //                startDate: startDate,
                        //                endDate: endDate
                        //            }
                        //        });
                        //};

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line